import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { icURL } from "./DataContextCopy";

export const LoginContext = createContext([]);

export const LoginProvider = ({ children }) => {
  const [loginRegionIds, setLoginRegionIds] = useState(0);

  const navigate = useNavigate();
  //로그인정보
  const [loginValue, setLoginValue] = useState({
    user_id: "",
    user_pwd: "",
  });

  const axiosInstance = axios.create({
    baseURL: "",
  });

  // 로그인 받아온 정보
  const [login, setLogin] = useState(null);
  const [isLoginState, setIsLoginState] = useState(false);

  const [errorMsg, setErrorMsg] = useState("");
  const encodeBase64 = (text) => {
    return btoa(unescape(encodeURIComponent(text)));
  };

  const LoginSubmit = (e) => {
    e.preventDefault();
    if (!loginValue.user_id || !loginValue.user_pwd) {
      setErrorMsg("아이디와 비밀번호를 제대로 입력 하였는지 확인해 주세요.");
      window.alert("아이디와 비밀번호를 제대로 입력 하였는지 확인해 주세요.");
      return;
    }

    // Base64 인코딩 확인을 위한 디버깅
    // console.log("Before encoding:", loginValue);

    const encodedLoginValue = {
      user_id: encodeBase64(loginValue.user_id),
      user_pwd: encodeBase64(loginValue.user_pwd),
    };

    // 인코딩된 값을 확인
    // console.log("Encoded Login Values:", encodedLoginValue);

    axios
      .post(`${icURL}/api/ascon/login`, encodedLoginValue)
      .then((res) => {
        if (res.data.success) {
          if (!res.data.data) {
            console.log(res.data.message);
            window.alert(res.data.message);
            throw new Error(res.data.data.message);
          } else {
            setLogin(res.data);
            setIsLoginState(true);

            navigate("/ascon");
          }
        } else {
          // setErrorMsg("아이디나 비밀번호가 올바르지 않습니다.");
          window.alert(res.data.message);
          console.error(res.data.message);
        }
      })
      .catch((error) => {
        console.error("err", error);
      });
  };

  // 로그인 성공시 토큰 저장
  useEffect(() => {
    if (login?.success === true) {
      localStorage.setItem("login", login.data.auth_token.access_token);
      localStorage.setItem("refresh", login.data.auth_token.refresh_token);
    } else {
    }
  }, [login]);

  const logout = () => {
    localStorage.removeItem("login");
    localStorage.removeItem("refresh");
    localStorage.removeItem("loginRegionIds");

    setIsLoginState(false);
    setLoginValue({
      user_id: "",
      user_pwd: "",
    });
    setLogin([]);
  };

  useEffect(() => {
    // Axios 인터셉터 설정
    const interceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const {
          config,
          response: { status },
        } = error;
        const originalRequest = config;

        // 토큰 만료 시 401 처리
        if (status === 401) {
          // 로그인 상태인 경우에만 처리
          if (isLoginState) {
            const refreshToken = localStorage.getItem("refresh");
            try {
              // 토큰 갱신 요청
              const res = await axiosInstance.get("/api/refresh", {
                headers: {
                  refresh_token: refreshToken,
                },
              });

              if (res.data.success) {
                const newTokenData = res.data.data;
                newTokenData.refresh_token = refreshToken;

                // 토큰 저장 및 원래 요청 재시도
                localStorage.setItem("login", newTokenData.access_token);
                originalRequest.headers.Authorization = `Bearer ${newTokenData.access_token}`;
                return axiosInstance(originalRequest);
              } else {
                // 토큰 갱신 실패 시 로그아웃 처리
                logout();
                navigate("/login");
                return Promise.reject(error);
              }
            } catch (err) {
              // 토큰 갱신 요청 실패 시 로그아웃 처리
              logout();
              navigate("/login");
              return Promise.reject(error);
            }
          } else {
            // 로그인 상태가 아닌 경우에는 로그아웃 처리
            logout();
            return Promise.reject(error);
          }
        }

        return Promise.reject(error);
      }
    );
    // 컴포넌트 언마운트 시 인터셉터 제거
    return () => {
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, [isLoginState]);

  return (
    <LoginContext.Provider
      value={{
        loginRegionIds,

        // 로그인
        LoginSubmit,
        loginValue,
        setLoginValue,

        isLoginState,
        setIsLoginState,
        login,
        setLogin,
        errorMsg,
        setErrorMsg,
        logout,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};
